// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import UserPage from '@/App';
import router from '@/router';
import store from '@/store';
import i18n from '@/locales/i18n';
import { Modal, Toast, ProgressBar, AlarmSound, FooterMsg } from '@/js/plugin';
import LoaderView from '@/components/common/LoaderView';

Vue.component('loader-view', LoaderView);
const fn = {};
let fnIndex = 0;
Vue.directive('click-outside', {
  bind(el, binding, vNode) {
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name;
      let warn = `[click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) {
        warn += `Found in component '${compName}' `;
      }
      console.warn(warn);
    }

    const handler = function (e) {
      if (el.contains(e.target)) {
        e.stopPropagation();
      } else {
        binding.value(e);
      }
    };
    fn[fnIndex] = handler;
    el.setAttribute('data-outside-id', fnIndex);
    window.addEventListener('mousedown', handler);
    window.addEventListener('touchstart', handler, { passive: true });
    fnIndex++;
  },
  unbind(el, binding, vNode) {
    const index = el.getAttribute('data-outside-id');
    window.removeEventListener('mousedown', fn[index]);
    window.removeEventListener('touchstart', fn[index], { passive: true });
    fn[index] = null;
    delete fn[index];
  },
});

Vue.config.productionTip = false;
Vue.config.performance = true;
Vue.use(Modal);
Vue.use(Toast);
Vue.use(ProgressBar);
Vue.use(FooterMsg);
Vue.use(AlarmSound);

/* eslint-disable no-new */
new Vue({
  el: '#main',
  router,
  i18n,
  store,
  components: { UserPage },
  template: '<UserPage/>',
});
